export default __webpack_public_path__ + "static/media/fpbh1000.bd94c920.png";